import { useParamsSearch } from '@anytag/shared-hooks';
import { PostsInsightSearchFilterSchemaType } from '../schemaTypes';

export const usePostsInsightFilter = () => useParamsSearch<PostsInsightSearchFilterSchemaType>();
